<div class="fe-dialog">
  <h2 mat-dialog-title>Folding Configuration — {{ data.dataSetName }}</h2>

  <mat-dialog-content>
    <div *ngIf="loading" class="fe-loading">Loading…</div>

    <div *ngIf="error" class="fe-error">{{ error }}</div>

    <form *ngIf="!loading" [formGroup]="form">

      <!-- Table -->
      <div class="fe-field">
        <label>Table <span class="fe-required">*</span></label>
        <input matInput formControlName="table" placeholder="e.g. WELLS.well" />
      </div>

      <!-- CascadeField -->
      <div class="fe-field">
        <label>Cascade Field <span class="fe-optional">(optional)</span></label>
        <input matInput formControlName="cascadeField" placeholder="e.g. wellId" />
      </div>

      <!-- Fold Keys -->
      <div class="fe-section-header">
        <strong>Fold Keys</strong>
        <button type="button" class="fe-btn fe-btn-sm" (click)="addKey()">+ Add Key</button>
      </div>

      <div formArrayName="keys">
        <div *ngFor="let key of keys.controls; let i = index"
             [formGroupName]="i"
             class="fe-key-card">

          <div class="fe-key-header">
            <span>Key {{ i + 1 }}</span>
            <button type="button" class="fe-btn fe-btn-danger fe-btn-sm" (click)="removeKey(i)">Remove</button>
          </div>

          <div class="fe-field">
            <label>Field <span class="fe-required">*</span></label>
            <input matInput formControlName="field" placeholder="e.g. api" />
          </div>

          <div class="fe-field">
            <label>Strip Characters <span class="fe-optional">(comma-separated)</span></label>
            <input matInput formControlName="stripChars" placeholder='e.g. -, space' />
          </div>

          <div class="fe-field fe-field-row">
            <div>
              <label>Truncate To <span class="fe-optional">(chars)</span></label>
              <input matInput type="number" formControlName="truncateTo" placeholder="e.g. 10" min="1" />
            </div>
            <div class="fe-checkbox">
              <mat-checkbox formControlName="caseInsensitive">Case Insensitive</mat-checkbox>
            </div>
          </div>

        </div>

        <div *ngIf="keys.length === 0" class="fe-empty">No fold keys defined.</div>
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="fe-btn fe-btn-ghost" (click)="dialogRef.close(false)">Cancel</button>
    <button class="fe-btn fe-btn-danger" (click)="clear()">Clear Config</button>
    <button class="fe-btn fe-btn-primary"
            [disabled]="form.invalid || saving"
            (click)="save()">
      {{ saving ? 'Saving…' : 'Save' }}
    </button>
  </mat-dialog-actions>
</div>
